import React from 'react';
// import Footer from './Footer';
 import { useNavigate } from "react-router-dom";
const ObjectDetectionPage = () => {
  const navigate = useNavigate();

  return (
    <>
      <style>{`
        .page-hero-title {
          opacity: 0;
          transform: translateY(28px) scale(0.98);
          animation: pageHeroTitleReveal 1s ease-out forwards;
        }

        @keyframes pageHeroTitleReveal {
          0% {
            opacity: 0;
            transform: translateY(28px) scale(0.98);
            letter-spacing: 0.02em;
            filter: blur(8px);
          }
          60% {
            opacity: 1;
            transform: translateY(-4px) scale(1.01);
            filter: blur(0);
          }
          100% {
            opacity: 1;
            transform: translateY(0) scale(1);
            letter-spacing: 0;
            filter: blur(0);
          }
        }
      `}</style>
      <div style={{ backgroundColor: '#ffffff', color: '#000' }}>
        <section className="section" style={{ maxWidth: 1200, margin: '0 auto', padding: '120px 20px' }}>

         {/* Back Button */}
        <div style={{ marginBottom: 30 }}>
          <p
         style={{
         display: "inline-block",
         cursor: "pointer",
         margin: 0,
         fontSize: 14,
         color: "#555555"
         }}
         onMouseEnter={(e) => (e.target.style.textDecoration = "underline")}
         onMouseLeave={(e) => (e.target.style.textDecoration = "none")}
         onClick={() => navigate("/", { state: { openMenu: true } })}
  >
        ← Back to Menu
      </p>
       </div>
            
          <h1 className="page-hero-title" style={{ marginBottom: 24, textAlign: 'left' }}>Object Detection & Tracking</h1>
          <p style={{ opacity: 0.85, lineHeight: 1.7, maxWidth: 900 }}>
            AI models such as YOLO and Faster R-CNN enable drones to identify and follow vehicles, people,
            and animals across complex terrains. We combine real-time inference with sensor fusion to deliver
            stable tracking even under occlusions and rapid motion.
          </p>

          <div style={{ marginTop: 32 }}>
            <h2 style={{ textAlign: 'center', marginBottom: 16 }}>How AI Enhances Drones</h2>
            <ul style={{ listStyle: 'disc', paddingLeft: 20, lineHeight: 1.8 }}>
              <li><strong>Autonomous Navigation</strong>: Vision + GPS + onboard sensors for flight without human intervention.</li>
              <li><strong>Object Detection & Tracking</strong>: Identify and follow targets like vehicles, people, wildlife.</li>
              <li><strong>Image & Video Analysis</strong>: Detect anomalies and changes over time from aerial footage.</li>
              <li><strong>Surveillance & Security</strong>: Monitor large areas and detect intrusions in real time.</li>
              <li><strong>Disaster Response</strong>: Assess damage, locate survivors, and plan rescue missions.</li>
              <li><strong>Delivery Services</strong>: Optimize routes and ensure safe autonomous delivery.</li>
            </ul>
          </div>

          <div style={{ marginTop: 32 }}>
            <h2 style={{ textAlign: 'center', marginBottom: 16 }}>Detection & Tracking Stack</h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 16 }}>
              <div style={{ border: '1px solid #333', padding: 16 }}>
                <h3>Models</h3>
                <p>YOLOv5/v8, Faster R-CNN, DeepSORT, ByteTrack for robust tracking.</p>
              </div>
              <div style={{ border: '1px solid #333', padding: 16 }}>
                <h3>Sensors</h3>
                <p>RGB, thermal IR, LiDAR, GPS/IMU for multi-modal perception.</p>
              </div>
              <div style={{ border: '1px solid #333', padding: 16 }}>
                <h3>Optimization</h3>
                <p>ONNX/TensorRT, quantization, tiling, and region-of-interest pipelines.</p>
              </div>
              <div style={{ border: '1px solid #333', padding: 16 }}>
                <h3>Use Cases</h3>
                <p>Wildlife conservation, traffic analysis, perimeter security, logistics.</p>
              </div>
            </div>
          </div>

          <div style={{ marginTop: 32 }}>
            <h2 style={{ textAlign: 'center', marginBottom: 16 }}>Real-World Examples</h2>
            <ul style={{ listStyle: 'disc', paddingLeft: 20, lineHeight: 1.8 }}>
              <li>Wildlife conservation drones track endangered species without disturbance.</li>
              <li>Police departments use AI drones for crowd monitoring and traffic management.</li>
              <li>Agriculture drones analyze crop health to detect diseases and deficiencies.</li>
            </ul>
          </div>
        </section>
      </div>
      {/* <Footer /> */}
    </>
  );
};

export default ObjectDetectionPage;


